import { createAsyncThunk } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { FCMService } from "Services/axios/FCM.Service";
import { handleApiError } from "Features/Common/ErrorHandler";
import { isDevelopmentRuntime } from "Utils/environment";

export const sendNotification = createAsyncThunk(
  "PushNotif/sendNotification",
  async (data) => {
    try {
      const formData = new FormData();

      formData.append("title", data?.title);
      formData.append("body", data?.body);
      formData.append("image", data?.image);
      formData.append("scheduled_at", data?.scheduled_at);
      data?.topics?.forEach((topics) => {
        const topicPrefix = isDevelopmentRuntime() ? 'dev_' : '';
        if (topics?.id === 1) {
          formData.append(`topics[]`, `${topicPrefix}global`);
          console.log(`${topicPrefix}global`);
        } else if (topics?.id === 2) {
          formData.append(`topics[]`, `${topicPrefix}is_not_verified`);
          console.log(`${topicPrefix}is_not_verified`);
        } else {
          formData.append(`topics[]`, `${topicPrefix}membership_${topics?.id}`);
          console.log(`${topicPrefix}membership_${topics?.id}`);
        }
      });
      formData.append("data[url]", data?.url || "");
      formData.append("data[event]", "Push_Topic");
      formData.append("data[description]", "Ini adalah push notification dari admin.");

      // Analytics label dengan prefix dev_ untuk development
      if (data?.analytics_label) {
        const labelPrefix = isDevelopmentRuntime() ? 'dev_' : '';
        formData.append("data[analytics_label]", `${labelPrefix}${data.analytics_label}`);
      }

      console.log(data);

      let response;
      if (data?.token !== undefined && data?.token !== null && data?.token !== "") {
        formData.append("token", data?.token);
        response = await FCMService.send(formData);
      } else {
        response = await FCMService.create(formData);
      }

      Swal.fire({
        icon: "success",
        title: "Sukses",
        text: "Notifikasi berhasil dikirim.",
      });

      data.successCallback && data.successCallback();

      return response.data.data;
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  }
);